import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AddBucketDrawerData, DrawerService } from '../../../services/drawer.service';
import { DRAWER_DATA } from 'src/app/shared/injector-tokens';
import { DrawerLayoutComponent } from '../../drawer-layout/drawer-layout.component';
import { AddBucketComponent } from '../../../buckets/add-bucket/add-bucket.component';

@Component({
  selector: 'app-add-bucket-drawer-wrapper',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './add-bucket-drawer-wrapper.component.html',
  imports: [DrawerLayoutComponent, AddBucketComponent],
})
export class AddBucketDrawerWrapperComponent {
  private data = inject<AddBucketDrawerData>(DRAWER_DATA);
  drawerService = inject(DrawerService);

  groupId?: string;
  constructor() {
    this.groupId = this.data.groupId;
  }
}
